import * as React from 'react';

import {getCommaSeparatedList} from 'nutshell-core/get-comma-separated-list';

import {Body} from 'shells/typography/body';

import type {
    MeetingStubFragment,
    GetSessionUser_loggedInUser as User,
} from 'nutshell-graphql-types';

import {getTeamName} from '../helpers';

export const getHostSection = (meeting: MeetingStubFragment, user?: User | null) => {
    let text = '';
    if (meeting.meetingType === 'ROUND_ROBIN') {
        // @ts-expect-error
        text = getTeamName(meeting.team, meeting.hosts);
    } else if (meeting.cohosts.length) {
        text = getCommaSeparatedList([
            meeting.creator.name,
            ...meeting.cohosts.map((cohost) => cohost.name),
        ]);
    } else if (user && user.permissions.canViewAllMeetings) {
        text = meeting.creator.name;
    }

    return <Body size='small'>{text}</Body>;
};
